module.exports = __webpack_public_path__ + "static/media/offices (7).42d19135.webp";